import { addPageState } from '../../actions/game/gameState.actions'

const battleMiddleware = ({ dispatch }) => next => (action) => {
    const { type, meta } = action
    const { gameState } = meta || {}

    if (!gameState) {
        next(action)
        return
    }

    switch (gameState) {
        case 'routing': {
            dispatch(addPageState(type))
            next(action)
            break
        }

        default: {
            next(action)
        }
    }
}

export default battleMiddleware
